"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    onClick: function () {
        // action
    },
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map